import { render, staticRenderFns } from "./TrustpilotWidget.vue?vue&type=template&id=4d6bce17&scoped=true&"
import script from "./TrustpilotWidget.vue?vue&type=script&lang=js&"
export * from "./TrustpilotWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrustpilotWidget.vue?vue&type=style&index=0&id=4d6bce17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bce17",
  null
  
)

export default component.exports